module.exports = __webpack_public_path__ + "img/background-mobile.56f5490e.png";